module.exports = __webpack_public_path__ + "static/media/ada.a9d19f2c.png";